// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsCorrelationMatrixAppModule } from './app.module';
bootstrapAppModule(MutualFundsCorrelationMatrixAppModule);
